<du-config-overview [overviewModel]="queryModel"></du-config-overview>
